export const ANNOTATION_CODE_OWNERSHIP = 'appfolio.com/code-ownership';
